import $ from "jquery";

export default class Landing {
  constructor(){
    this.config = {
      bookButton: '.book__product__nav',
      bookFirstChild: '.book__product__images__img:first-child',
      bookLastChild: '.book__product__images__img:last-child',
      slideshow: '#js__book__slideshow',
      books: '.book__product__images__img',
      hearValue: '#js__hear__value',
    }
  }
  getNextSlide(){
    $(this.config.bookFirstChild).hide().css({opacity: 0}).next().css({display: 'flex'}).animate({
      opacity: 1
    }).end().appendTo(this.config.slideshow);
  }

  getPrevSlide() {
    $(this.config.bookFirstChild).hide().css({opacity: 0});
    $(this.config.bookLastChild).prependTo(this.config.slideshow).hide();
    $(this.config.bookFirstChild).css({display: 'flex'}).animate({ opacity: 1 }, 200);
  }

  initialPageAnimation(){
    // if only one book exists, hide the arrows
    if($(this.config.books).length === 1){
      $(this.config.bookButton).hide();
    }
  }

  // Handle the toggling of book types
  toggleBookType(e){
    if(e.target.value === 'Hardback'){
      // toggle the price
      $('#js__hardback').show();
      $('#js__paperback').hide();

      // toggle the hidden paypal buttons
      $("#js__paypal__hardback").prop('disabled', false);
      $("#js__paypal__paperback").prop('disabled', true);

    } else if(e.target.value === 'Paperback'){
      // toggle the price
      $('#js__paperback').show();
      $('#js__hardback').hide();

      // toggle the hidden paypal buttons
      $("#js__paypal__paperback").prop('disabled', false);
      $("#js__paypal__hardback").prop('disabled', true);

    }
  }

  // set heard about
  setHear(e){
    $(this.hearValue).value = e.target.value;
  }
}



// WEBPACK FOOTER //
// src/scripts/Book.js